// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"78adae0460333afb25f1","655":"f6adf915a96661f2b2e0"}[chunkId] + ".js";
};